module.exports = __webpack_public_path__ + "img/twocan-intro-screens.1aedf897.png";